import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import localeFi from '@angular/common/locales/fi';
import localeNl from '@angular/common/locales/nl';
import { LocaleService } from './services/locale.service';
import { AuthService } from './services/auth.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from 'src/environments/local/environment';
import { TrackingService } from './services/tracking.service';
import { Title, Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  showFooter = false;
  private subs: Array<Subscription> = [];
  private enabledLanguages = ['en', 'sv', 'fi', 'nl'];

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private localeService: LocaleService,
    private router: Router,
    private authService: AuthService,
    private gtmService: GoogleTagManagerService,
    private trackingService: TrackingService,
    private titleService: Title,
    private metaService: Meta,
  ) {
    translate.addLangs(this.enabledLanguages);
    translate.setDefaultLang('en');
    translate.use(environment.defaultLanguage);
    this.gtmService.addGtmToDom();
  }

  ngOnInit(): void {
    registerLocaleData(localeSv, 'sv');
    registerLocaleData(localeFi, 'fi');
    registerLocaleData(localeNl, 'nl');
    this.titleService.setTitle(environment.pageTitle);
    this.metaService.addTag({ name: 'description', content: environment.pageDescription });
    this.subs.push(
      this.route.queryParams.subscribe((params) => {
        const { lang } = params;
        if (
          this.enabledLanguages.includes(lang) &&
          this.translate.currentLang !== lang
        ) {
          this.translate.use(lang);
        }
      })
    );
    this.subs.push(
      this.router.events.subscribe((e) => {
        if (e instanceof NavigationEnd) {
          this.showFooter = e.url.includes('basic-info');
        }
      })
    );
    this.localeService.currency = environment.currency;
    this.localeService.locale = environment.locale;

    // Setup page view tracking
    this.router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        this.trackingService.trackPageView(item.url);
        this.trackingService.trackFlow(item.url);
      }
    });
  }

  get showContact(): boolean {
    const url = this.router.url;
    return (
      this.authService.accessToken.length > 0 && url.includes('summary')
    );
  }

  ngOnDestroy(): void {
    this.subs.map((s) => s.unsubscribe());
  }
}
